<template>
  <el-pagination
      :small="small"
      background
      :layout="layout"
      :page-sizes="pagingData.pageList"
      :total="pagingData.total"
      :page-size.sync="pagingData.pageSize"
      :current-page.sync="pagingData.currentPage"
      @size-change="pagingChange"
      @current-change="pagingChange">
  </el-pagination>
</template>

<script>
export default {
  name: "vuePagination",
  props: {
    pagingData: Object,
    small: Boolean,
    layout: {
      type: String,
      default: "prev, pager, next, sizes, jumper",
    }
  },
  data() {
    return {
      timer: null,
    }
  },
  watch: {
    "pagingData.total": {
      handler(total) {
        const {currentPage, pageSize} = this.pagingData;
        if (currentPage > 1 && currentPage * pageSize - total >= pageSize) {
          this.pagingData.currentPage = Math.ceil(total / this.pageSize) || 1;
          this.$emit("getData")
        }
      },
      deep: true
    }
  },
  methods: {
    pagingChange() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.$emit("getData"));
    },
  }
}
</script>

<style scoped>

</style>
